import { IWeeklyBoosterContent } from 'src/app/@types/boosters';
import { ITab } from 'src/app/@types/tabs';

/**
 * Represents a single card in the booster flow
 */
export interface IBoosterCard {
  type: 'objective' | 'advice' | 'feedback';
  stepOrder?: number; // Only for advice/feedback cards
  content: string;
  tabIndex: number; // Which tab this card belongs to (for tab highlighting)
}

/**
 * Creates cards from IWeeklyBoosterContent
 * Each step has two cards: adviceMessage and feedbackMessage
 * @param content - The weekly booster content containing objective and steps
 * @returns Object containing tabs array and cards array
 */
export function createTabsAndCardsFromContent (content: IWeeklyBoosterContent): {
  tabs: ITab[];
  cards: IBoosterCard[];
} {
  const tabs: ITab[] = [];
  const cards: IBoosterCard[] = [];
  let tabIndex = 0;

  // Add Objective tab and card
  if (content.objective) {
    tabs.push({
      title: 'Objective',
    });
    cards.push({
      type: 'objective',
      content: content.objective,
      tabIndex,
    });
    tabIndex++;
  }

  // Add Step tabs and cards, sorted by order
  if (content.steps && content.steps.length > 0) {
    const sortedSteps = [...content.steps].sort((a, b) => a.order - b.order);

    sortedSteps.forEach((step) => {
      // Skip steps with no advice or feedback while BE is adjusting the response
      if (!step.adviceMessage || !step.feedbackMessage) {
        return;
      }

      // Add tab for this step
      tabs.push({
        title: `Step ${step.order + 1}`,
      });

      // Add advice card
      if (step.adviceMessage) {
        cards.push({
          type: 'advice',
          stepOrder: step.order + 1,
          content: step.adviceMessage,
          tabIndex,
        });
      }

      // Add feedback card
      if (step.feedbackMessage) {
        cards.push({
          type: 'feedback',
          stepOrder: step.order,
          content: step.feedbackMessage,
          tabIndex,
        });
      }

      tabIndex++;
    });
  }

  return { tabs, cards };
}
